import { orpc } from "@/utils/orpc.client";
import type { FeaturePageFamily } from "@garimpa/lib/featurePage";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function getFeaturePageLandingQueryOptions(input: {
  family: FeaturePageFamily;
  locale: ViewerLocale;
}) {
  return orpc.featurePages.getLanding.queryOptions({ input });
}
